import type { AppModule } from '@ugi/core';

import * as routes from './routes.js';

export const UsersModule: AppModule = {
  routes,
};
